<template>
<div>
    <div class="container">
        <div v-if="loading" class="loading"></div>
        <b-form-group
                id="select-price"
                label="Вид цены"
                label-for="price"
        >
            <b-form-select v-model="price" @change="changePrice($event)">
                <b-form-select-option id="price_dealer" value="Дилер">Дилер</b-form-select-option>
                <b-form-select-option id="price_optovik" value="Оптовик">Оптовик</b-form-select-option>
            </b-form-select>
        </b-form-group>
    </div>
</div>

</template>

<script>
    export default {
        name: "SettingsManager",
        data(){
            return{
                loading: false,
                price: false
            }
        },

        mounted() {
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'manager/check-price')
                .then(response => {
                    this.price = response.data.price
                }).catch(error => {

                }).finally(() => {
                    this.loading = false
                });
        },

        methods: {
            changePrice: function(event) {
                this.axios
                    .post(this.axios.defaults.baseURL + 'manager/change-price', {
                        'price': this.price
                    })
                    .then(response => {
                        if(response.data.message == 'success') {
                            this.$router.push({name: 'SettingsManager', params: {message: 'Вид был изменен'}})
                        }
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/app/manager/SettingsManager.vue